<template>
  <div>
    <Form>
      <Table border stripe height="480" ref="table1" :columns="columns1" :data="data" :loading="loading" @on-selection-change="selectChange" @on-select-cancel="handleCancel1"  @on-select="handleSelect1" @on-select-all="handleSelectAll1" @on-select-all-cancel="handleCancelSelectAll1">
      </Table>
      <Table border stripe height="480" ref="exportCsvtable" :columns="columns1" :data="exportCsvdata" v-show="false">
      </Table>
      <Row style="margin-top:15px">
        <Col span="14">
          <Page :total="total" :page-size="pageInfo.pageSize" @on-change="pageChange" />
        </Col>
        <Col span="10" style="text-align: right">
          <Button type="primary" icon="ios-arrow-back" @click="returnPage()">返回</Button>
          <Button type="primary" icon="ios-download" :loading="exportBtnLoading" @click="exportCsv()">导出</Button>
          <Button type="primary" icon="md-cloud-upload" @click="importPop=true" >导入</Button>
          <Button type="success" icon="md-add" @click="btnAdd()">追加</Button>
          <Button type="error" icon="ios-trash" :disabled="disDel" @click="btnDel()">删除</Button>
        </Col>
      </Row>
    </Form>
    <Modal v-model="importPop" title="导入" :mask-closable="false" @on-cancel="cancel">
        <Table border stripe height="480" ref="importPop" :columns="improtcolumns1" :data="importdata" />
        <span style="margin-top:10px">共{{count}}条</span>
        <div class="bottomBtn" slot="footer">
            <Button type="primary" @click="handelFile" :disabled="noclick">选择文件</Button>
            <input type="file" ref="uploadExcel" accept=".xlsx,.xls" id="excel-file" @change="importExcel" v-show="false">
            <Button type="primary" @click="importComfirm()" :disabled="noclick">保存</Button>
        </div>
    </Modal>
    <Modal v-model="showAdd" width="55%" footer-hide>
      <p class="addtitle">角色权限设定(追加)</p>
      <Form
        :label-width="70"
        label-position="left"
        :show-message="false"
        style="margin-top: 10px"
      >
        <Row>
          <Col span="5" style="margin-right: 20px">
            <FormItem label="员工编号:" :label-width="85">
              <Input v-model="formItem.user_id" />
            </FormItem>
          </Col>
          <Col span="5" style="margin-right: 20px">
            <FormItem label="用户名:">
              <Input v-model="formItem.user_name" />
            </FormItem>
          </Col>
          <Col span="5" style="margin-right: 20px">
            <FormItem label="所在部门:" :label-width="85">
              <Select  :clearable="true" placeholder="">
                <Option :value="item.code" v-for="(item, i) in departmentList" :key="i">
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="5" style="margin-right: 20px">
            <FormItem label="所属职位:" :label-width="85">
              <Select  :clearable="true" placeholder="">
                <Option :value="item.code" v-for="(item, i) in departmentList" :key="i">
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="1">
            <Button @click="pageInfo2.pageNo=1,total2=0,search()" type="primary"><!-- 检索 -->{{$t('Search')}}</Button>
          </Col>
        </Row>
        <Table border stripe ref="table2" :columns="columns2" :data="roleTable" :loading="loading" @on-selection-change="selectChange2()" @on-select-cancel="handleCancel"  @on-select="handleSelect2" @on-select-all="handleSelectAll" @on-select-all-cancel="handleCancelSelectAll2">
        </Table>
        <Row style="margin-top:15px">
          <Page :total="total2" :page-size="pageInfo2.pageSize" @on-change="pageChange2" />
          <Col span="24" style="text-align: center">
            <Button type="success" :disabled="disSel" @click="selectRole()">选择</Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  data() {
    return {
      columns1: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "角色ID",
          key: "role_id",
        },
        {
          title: "员工编号",
          key: "user_id",
        },
        {
          title: "员工姓名",
          key: "user_name",
        },
      ],
      improtcolumns1:[
        {
          title: "角色ID",
          key: "role_id",
        },
        {
          title: "员工编号",
          key: "user_id",
        },
        {
          title: "员工姓名",
          key: "user_name",
        },
      ],
      data: [],
      exportCsvdata:[],
      exportBtnLoading:false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      pageInfo2: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      total: 1,
      total2: 1,
      row: null,
      disDel: true,
      showAdd: false,
      formItem: {},
      departmentList:[],
      selectList:[],
      loading:false,
      columns2:[
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "员工编号",
          key: "user_id",
        },
        {
          title: "角色名称",
          key: "user_name",
        },
        {
          title: "所在部门",
        },
        {
          title: "所属职位",
        },
        ],
      roleTable:[],
      disSel:true,
      selection:'',
      selected:[],
      noclick:false,
      importPop:false,
      importdata:[],
      count:0
    };
  },
  mounted(){
    this.searchRole()

  },
  methods: {
    searchRole(){
      let obj = {
        role_id: this.getQueryVariable('id'),
        pageNum: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
      }
      this.loading = true
      axios.post("/Role/selectRolePerson",obj).then((res) => {
        this.loading = false
        if(res){
          this.data = res.basicList
          this.total = Number(res.total)
          this.updateChecked1()
        } 
      })
    },
    searchALLRole(){
      let obj = {
        role_id: this.getQueryVariable('id'),
        pageNum: 1,
        pageSize: 10000,
      }
      this.exportBtnLoading=true
      axios.post("/Role/selectRolePerson",obj).then((res) => {
        if(res){
          this.exportBtnLoading=false
          this.exportCsvdata = res.basicList
          if(this.exportCsvdata.length>1){
            this.$nextTick(()=>{
              this.$refs.exportCsvtable.exportCsv({
                  filename: '角色权限'
              });
            })
          }
        } 
      })
    },
    selectChange(){
      this.selected.length == 0 ? this.disDel=true : this.disDel=false
      console.log(this.selected)
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.searchRole()
    },
    btnDel(){
      if(this.selected.length !== 0 && this.data.length > 0){
        this.$Modal.confirm({
          title: this.$notice('deletion'),
          content: "",
          onOk: () => {
            axios.post("/Role/deleteRolePerson", this.selected).then((res) => {
              this.searchRole()
              this.selected = [];
            })
          },
          onCancel: () => {},
        });
      }
    },
    updateChecked1() {
      for (var i = 0; i < this.data.length; i++) {
        this.data[i]._checked = false;
        for (var j = 0; j < this.selected.length; j++) {
          if (this.selected[j].user_id === this.data[i].user_id) {
            this.data[i]._checked = true;
          }
        }
      }
    },
    // 选中某一项
    handleSelect1(selection, row) {
      this.selected.push(row);
    },
    handleCancel1(selection, row) {
      let newProductData = this.selected.filter(item => {
        return item.user_id !== row.user_id
      })
      this.selected = newProductData
    }, 
    //全选
    handleSelectAll1(selection) {
      selection.forEach(item => {
        this.selected.push(item)
      });
      // 去重
      const res = new Map();
      this.selected = this.selected.filter(item => !res.has(item.user_id) && res.set(item.user_id, 1));
    }, 
    // 取消全选,从已选项中移除当页数据
    handleCancelSelectAll1(selection) {
      var flag1 = true
      let arr = []
      for (var i = 0; i < this.selected.length; i++) {
        flag1 = true
        for (var j = 0; j < this.data.length ; j++) {
          if (this.selected[i].user_id == this.data[j].user_id) {
            flag1 = false
            break;
          }
        }
        if(flag1){
          arr.push(this.selected[i])
        }
      }
      this.selected = arr
    },


// 表2
    updateChecked() {
      for (var i = 0; i < this.roleTable.length; i++) {
        this.roleTable[i]._checked = false;
        for (var j = 0; j < this.selectList.length; j++) {
          if (this.selectList[j].user_id === this.roleTable[i].user_id) {
            this.roleTable[i]._checked = true;
          }
        }
      }
    },
    // 选中某一项
    handleSelect2(selection, row) {
      this.selectList.push(row);
    },
    handleCancel(selection, row) {
      let newProductData = this.selectList.filter(item => {
        return item.user_id !== row.user_id
      })
      this.selectList = newProductData
    }, 
    //全选
    handleSelectAll(selection) {
      selection.forEach(item => {
        this.selectList.push(item)
      });
      // 去重
      const res = new Map();
      this.selectList = this.selectList.filter(item => !res.has(item.user_id) && res.set(item.user_id, 1));
    }, 
    // 取消全选,从已选项中移除当页数据
    handleCancelSelectAll2(selection) {
      var flag = true
      let arr = []
      for (var i = 0; i < this.selectList.length; i++) {
        flag = true
        for (var j = 0; j < this.roleTable.length ; j++) {
          if (this.selectList[i].user_id == this.roleTable[j].user_id) {
            flag = false
            break;
          }
        }
        if(flag){
          arr.push(this.selectList[i])
        }
      }
      this.selectList = arr
      console.log(this.selectList)
    },
    selectChange2(){
      this.selectList.length == 0 ? this.disSel=true : this.disSel=false
    },
    btnAdd() {
      this.showAdd = true;
      this.search()
    },
    search(){
      let obj = {
        user_id: this.formItem.user_id,
        user_name: this.formItem.user_name,
        pageNum: this.pageInfo2.pageNo,
        pageSize: this.pageInfo2.pageSize,
        role_id: this.getQueryVariable('id'),
      }
      this.loading = true
      axios.post("/Role/selectUserInfo", obj).then((res) => {
        this.loading = false
        if(res){
          this.roleTable = res.basicList
          this.total2 = Number(res.total)
          this.updateChecked()
        } 
      })
    },
    pageChange2(val){
      this.pageInfo2.pageNo = val;
      this.search()
    },
    selectRole(){
      if(this.selectList.length > 0){
        this.selectList.forEach(item=>{
          item.role_id = this.getQueryVariable('id')
        })
      }    
      axios.post("/Role/insertRolePerson",this.selectList).then((res) => {
        this.loading = false
        this.searchRole()
        this.selectList = []
        this.pageInfo2.pageNo = 1
        this.total2 = 0
      })
      this.showAdd = false
    },
    getQueryVariable(variable){
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return decodeURI(pair[1]) }
      }
      return(false);
    },
    exportCsv(){
      this.searchALLRole()
      
    },
    handelFile() {
      this.$refs.uploadExcel.click();

    },
    importExcel(e) {
      var file_name = document.getElementById('excel-file').value
      file_name = file_name.substring(file_name.lastIndexOf(".")).toLowerCase()
      var uploadFormat = ['.xlsx','.xls']
      if (file_name != uploadFormat[0] && file_name != uploadFormat[1]) {
        this.$Message.warning({
                content: this.$t('The_file_type_is_incorrect') + uploadFormat.join(' or ') + this.$t('Type'),
                duration: 5
            })
        return
      }
      this.$importExcel('excel-file',e,'importPop',(data) => {
        console.log(data)
        this.count = data.length
         this.importdata = data
      })
    },
     //插入数据
    importComfirm(){
      this.$Modal.confirm({
            title: this.$notice('sureSave'),
            content: '',
            onOk: () => {
                this.noclick = true
                axios.post("/Role/insertBatchRolePerson", this.importdata).then((res) => {
                  this.noclick = false
                  if(res){
                    if(this.importdata.length > 0){
                        this.$Message.success('导入成功');
                        
                        this.importPop=false
                        this.searchRole()
                        this.importdata = [];
                    }
                  }
                
                })
            }
        });
        
       
    },
    cancel(){
      this.importdata = [];
      this.noclick = false
    },
    returnPage(){
      this.$router.back()
    }
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/OrganizationMaintenance/RoleMessEdit.vue